import { none } from 'fp-ts/es6/Option'
import { Right } from 'generated/graphql'
import { LoginContextPartner, LoginContextValues } from '@amzn/aapn-stage-dive-shared-types'
import * as React from 'react'
import { FunctionComponent, PropsWithChildren, useContext, useState } from 'react'
import * as O from 'fp-ts/es6/Option'
import { ACCREDITATION_PARTNER } from '../../../shared/constants'

export const defaultContextValue = {
  partnerProfileId: none,
  userId: none,
  userName: none,
  userEmail: none,
  inside: false,
  userRights: new Set<Right>(),
  partnerStatus: none,
  partnerAccreditation: O.some(ACCREDITATION_PARTNER),
  partnerUserRole: none,
  availablePartners: [] as LoginContextPartner[],
  ownedPartnerGroup: none,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  invalidate: (): void => {},
}

interface LoginContextInterface {
  loginContext: LoginContextValues
}

const LoginContext = React.createContext<LoginContextInterface>({ loginContext: defaultContextValue })

interface LoginContextProviderProps {
  defaultValue?: LoginContextValues
}

export const LoginContextProvider: FunctionComponent<LoginContextProviderProps> = (props: PropsWithChildren<LoginContextProviderProps>) => {
  const [loginContext] = useState<LoginContextValues>(props.defaultValue ?? defaultContextValue)

  return <LoginContext.Provider value={{ loginContext }}>{props.children}</LoginContext.Provider>
}

export const useLoginContext: () => LoginContextInterface = () => useContext(LoginContext)

// Fallback for intermittent Firefox bug where context always returns default vals for tenants
export const getLoginContextWithFallback: () => LoginContextValues = () => {
  const { loginContext } = useLoginContext()
  if (JSON.stringify(loginContext) === JSON.stringify(defaultContextValue)) {
    const sessionStorageLoginContext = sessionStorage.getItem('loginContext') ?? ''
    return sessionStorageLoginContext ? JSON.parse(sessionStorageLoginContext) : loginContext
  }
  return loginContext
}
